module.exports = __webpack_public_path__ + "img/logo_map.854004cd.svg";